function importAll(r) {
  r.keys().forEach(r);
}

window.$ = $;
window.jQuery = $;
import "jquery.scrollto";
import Rails from "@rails/ujs";
Rails.start();

import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "jquery-colorbox";

importAll(require.context("promo/images", true));
import "normalize.css";
import "promo/styles/promo.sass";
import "scrolldepth/jquery.scrolldepth.min.js";

let sendData = function (name) {
  gtag("event", "click", {
    event_category: "Курсы промо",
    event_label: name,
  });
};

jQuery(function () {
  $(".b24-form-btn").on("click", function(){
    sendData("Заявка")
  });
});
